import { Box, Button, Typography, useTheme } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useState } from 'react';

import Timeslots from '@toolbox/components/Timeslots';
import { getUserTimeZone } from '@widget/utils/getUserTimezone';
import { getSalesTimeslots } from '@widget/core/getSalesTimeslots';
import { getTimeSlotDays } from '@widget/utils/getTimeSlotDays';
import { STEPS } from '@toolbox/components/HeaderCommon/CallBackBlock/constants';

import type { StepCommonType } from '@toolbox/components/HeaderCommon/CallBackBlock/types';
import type { FC } from 'react';
import type { TimeSlotType } from '@widget/api/types';

export type SlotsStepProps = StepCommonType & {
  slotsDescription?: string;
  slotsCtaLabel?: string;
};
export const SlotsStep: FC<SlotsStepProps> = ({
  slotsDescription,
  slotsCtaLabel,
  setData,
  setStep,
}) => {
  const timezone = getUserTimeZone();
  const timeslots = getSalesTimeslots();
  const theme = useTheme();
  const { days, firstTimeslotDate } = getTimeSlotDays(timeslots, timezone);
  const [date, setDate] = useState<string>(firstTimeslotDate);
  const [selectedTimeSlot, setSelectedTimeslot] = useState<null | TimeSlotType>(null);

  const { handleSubmit } = useForm();

  const onSubmit = () => {
    if (selectedTimeSlot === null) {
      return;
    }
    setData({ salesStartTime: selectedTimeSlot?.isoDateTime });
    setStep(STEPS.USER_DATA);
  };
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', overflow: 'auto' }}
    >
      <Box
        sx={{
          flex: '1 1 auto',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            flex: '1 1 auto',
            padding: '32px 32px 0',
            [theme.breakpoints.down('sm')]: {
              padding: '16px 16px 0',
            },
          }}
        >
          <Box mb={'16px'}>
            <Typography variant={'body1'} component={'h5'} color={'primary'}>
              {slotsDescription}
            </Typography>
          </Box>
          <Timeslots
            onChange={setSelectedTimeslot}
            selectedDate={date}
            selectedTimeslot={selectedTimeSlot}
            timeSlots={timeslots[date].slots}
            dayPickerProps={{
              days,
              onChange: (date: string) => setDate(date),
            }}
            timezone={timezone}
          />
        </Box>
      </Box>
      <Box
        sx={{
          padding: '32px',
          [theme.breakpoints.down('sm')]: {
            padding: '16px',
          },
        }}
      >
        <Button
          disabled={selectedTimeSlot === null}
          color={'secondary'}
          variant={'contained'}
          type="submit"
          fullWidth
          disableElevation
        >
          {slotsCtaLabel}
        </Button>
      </Box>
    </form>
  );
};
